import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Case_Arrow } from "../../../app-constants";
import { Link } from "gatsby";
import Logo1 from "../../images/location_new/caseimg/logo1.webp";
import Img1 from "../../images/location_new/caseimg/img1.webp";
import Logo12 from "../../images/location_new/caseimg/logo12.webp";
import Img12 from "../../images/location_new/caseimg/img12.webp";
import Logo3 from "../../images/location_new/caseimg/logo3.webp";
import Img3 from "../../images/location_new/caseimg/img3.webp";
import Logo10 from "../../images/location_new/caseimg/logo10.webp";
import Img10 from "../../images/location_new/caseimg/img10.webp";

const CaseStudy = [
  {
    logo: Logo12,
    title: "The Idea Behind AMJ Wellness",
    description:
      "Workplace Wellness, a cross-platform fitness app, is designed for companies recognizing the link between employee well-being, productivity, and organizational success.",
    link: "amj-wellness",
    technology: {
      iOS: "iOS",
      Android: "Android",
    },
    Img: Img12,
    BgColor: "#eb374080",
    TextColor: "#c41728",
  },
  {
    logo: Logo1,
    title: "The Idea Behind Nurse Practitioners",
    description:
      "The Nurse Practitioners app is meticulously crafted with a singular purpose: to transform healthcare and showcase technologys positive influence on the end-users.",
    link: "nurse-practitioners",
    technology: {
      iOS: "iOS",
      Android: "Android",
    },
    Img: Img1,
    BgColor: "#d5ccee",
    TextColor: "#6d4fc1",
  },
  {
    logo: Logo3,
    title: "The Idea Behind Reck’N",
    description:
      "An innovative solution that revolutionizes the restaurant experience, connecting customers and restaurants for seamless booking, enhanced social interaction, and efficient order processing.",
    link: "reck-n-case",
    technology: {
      iOS: "iOS",
      Android: "Android",
    },
    Img: Img3,
    BgColor: "#f5f5f5",
    TextColor: "#4041AB",
  },
  {
    logo: Logo10,
    title: "The Idea Behind Soundly",
    description:
      "Soundly has transformed the music experience, allowing music enthusiasts to stream millions of songs from emerging artists via the app, offering a new level of musical immersion.",
    link: "soundly",
    technology: {
      iOS: "iOS",
      Android: "Android",
    },
    Img: Img10,
    BgColor: "#f79789",
    TextColor: "#ec2125",
  },
];

function Stories(props) {
  return (
    <div className="section_stories p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="Success">
              <h2>App Success Stories</h2>
            </div>
            <p>
              Powerful apps, and hassle-free results – that's all we have to
              offer. Join the 100s of start-ups, scale-ups, and enterprises we
              helped rightly conceptualize, strategically build, and rapidly
              launch high-performing mobile apps. Need a proof? See yourself!
            </p>
          </Col>
          {CaseStudy.map((item, index) => (
            <Col
              xs={12}
              md={12}
              lg={6}
              xl={6}
              xxl={6}
              className="my-auto"
              key={index}
            >
              <div
                className="stories_item"
                style={{ backgroundColor: item.BgColor }}
              >
                <div className="item_logo">
                  <LazyLoadImage
                    src={item.logo}
                    effect="blur"
                    alt={item.title}
                    className="img-fluid"
                  />
                  <ul
                    style={{
                      color: item.TextColor,
                      borderColor: item.TextColor,
                    }}
                  >
                    <li>{item.technology.iOS}</li>
                    <li>{item.technology.Android}</li>
                  </ul>
                </div>
                <div className="item_tech">
                  <div className="tech_content">
                    <h4 style={{ color: item.TextColor }}>{item.title}</h4>
                    <p>{item.description}</p>

                    <Link
                      to={
                        item.link
                          ? `/case-studies/${item.link}`
                          : "https://www.tekrevol.com/projects"
                      }
                      className="case_btn"
                      aria-label="TekRevol Contact"
                      style={{ backgroundColor: item.TextColor }}
                    >
                      View Case Study {Case_Arrow}
                    </Link>
                  </div>
                  <div className="tech_img">
                    <LazyLoadImage
                      src={item.Img}
                      effect="blur"
                      alt={item.title}
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}

export default Stories;
